/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsManagementEditNewsResponse } from './NewsManagementEditNewsResponse';

export type NewsManagementEditNewsResponseApiRespoonse = {
    data?: NewsManagementEditNewsResponse;
    status?: NewsManagementEditNewsResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace NewsManagementEditNewsResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

